var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 30.2354C10.65 30.2354 12 28.8854 12 27.2354V16.7354C12 15.0854 10.65 13.7354 9 13.7354C7.35 13.7354 6 15.0854 6 16.7354V27.2354C6 28.8854 7.35 30.2354 9 30.2354ZM24 22.7354V27.2354C24 28.8854 25.35 30.2354 27 30.2354C28.65 30.2354 30 28.8854 30 27.2354V22.7354C30 21.0854 28.65 19.7354 27 19.7354C25.35 19.7354 24 21.0854 24 22.7354ZM18 30.2354C19.65 30.2354 21 28.8854 21 27.2354V9.23535C21 7.58535 19.65 6.23535 18 6.23535C16.35 6.23535 15 7.58535 15 9.23535V27.2354C15 28.8854 16.35 30.2354 18 30.2354Z",
    fill: "#3969D5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/bar-chart.c362006c6f6f369aa1a25027b441b435.svg";
export { ForwardRef as ReactComponent };